module.exports = __webpack_public_path__ + "img/singleblueplus-icon.5499a221.svg";